import React, {FC, useMemo} from 'react';

import {blendColors} from '../../../../libs/shared/core/src/models/helpers/colorHelpers';
import {DropdownItemAvatar} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemAvatar';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {TeammateOnlineStatusesEnum} from '../../../store/data/teammates/onlineTeammatesSelectors';
import {TeammateAvatarWithStatus} from '../avatars/teammateAvatarWithStatus';
import {DropdownItemTeammateAvatarProps} from './dropdownItemTeammateAvatar';

/*
 * Props.
 */

interface DropdownItemTeammateAvatarWithStatusProps extends DropdownItemTeammateAvatarProps {
  /** Whether the teammate is online. */
  onlineStatus: TeammateOnlineStatusesEnum;
}

/*
 * Component.
 */

export const DropdownItemTeammateAvatarWithStatus: FC<DropdownItemTeammateAvatarWithStatusProps> = ({
  teammate,
  onlineStatus,
}) => {
  const theme = useUserTheme();
  const borderHoverColor = useMemo(() => blendColors(theme.foreground, theme.alphas.gray10), [theme]);

  return (
    <DropdownItemAvatar>
      <TeammateAvatarWithStatus
        borderColor={theme.foreground}
        borderHoverColor={borderHoverColor}
        teammate={teammate}
        isUnavailable={!teammate.isAvailable}
        onlineStatus={onlineStatus}
        size={VisualSizesEnum.MEDIUM}
      />
    </DropdownItemAvatar>
  );
};
